import PropTypes from 'prop-types';
import React from 'react';

import { PATHS } from '@constants/paths';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Avatar, Box, Button, IconButton, Menu, MenuItem, Toolbar, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { CashinProgressBanner } from '@features/cashier/pages/cashin/CashinProgressBanner';
import ConnectionClock from '@shared/components/layouts/ConnectionClock';
import { useCurrentUser } from '@shared/hooks';
import { logoutService } from '@shared/services/api/authService';
import { cancelActiveRemittanceOrder } from '@shared/utils/activeRemittanceOrder';
import { signOut } from '@store/actions/auth/authAction';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import EventEmitter from 'reactjs-eventemitter';

import logoImg from '@assets/yolo.svg';
import './Dashboard.scss';

const AppBarHeader = ({ onDrawerToggle, mobileOpen }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const user = useCurrentUser();
  const { change_password: changePassword } = user;
  const navigate = useNavigate();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    navigate(PATHS.PROFILE2);
    setAnchorEl(null);
  };

  const dismissCredentials = async () => {
    const tenant = user.correspondent;
    dispatch(signOut());
    navigate(`${PATHS.LOGIN_TENANT}/${tenant}`, { replace: true });
  };

  const handlelogOut = async () => {
    const profileId = user.profile_id;
    const tenant = user.correspondent;
    await cancelActiveRemittanceOrder();
    dispatch(signOut());
    navigate(`${PATHS.LOGIN_TENANT}/${tenant}`, { replace: true });
    if (profileId != null && profileId !== '') {
      logoutService(profileId).catch(() => {});
    }
  };

  EventEmitter.subscribe('logout', () => {
    dismissCredentials();
  });

  return (
    <AppBar
      className="appbar-header"
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        transition: (theme) =>
          theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        height: 'var(--appbar-height)',
      }}>
      <Toolbar className="toolbar" sx={{ minHeight: 'var(--appbar-height)' }}>
        {mobileOpen
          ? !changePassword && (
              <IconButton edge="start" color="inherit" onClick={onDrawerToggle} aria-label="open drawer">
                <ChevronLeftIcon />
              </IconButton>
            )
          : !changePassword && (
              <IconButton edge="start" color="inherit" onClick={onDrawerToggle} aria-label="open drawer">
                <MenuIcon />
              </IconButton>
            )}
        <Typography component="h1" variant="h6" noWrap className="title">
          <img src={logoImg} alt="logo" className="header-logo" />
        </Typography>
        <ConnectionClock />
        <CashinProgressBanner />
        <Button onClick={handleMenuClick} className="header-avatar-button">
          <Avatar src={user.picture} className="header-avatar" />
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <Grid>
              <p className="avatar-data">{user.name}</p>
              <p className="avatar-data-detail">{user.correspondent_name}</p>
            </Grid>
          </Box>
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          elevation={0}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}>
          <MenuItem onClick={handleProfile}>Mi perfil</MenuItem>
          <MenuItem onClick={handlelogOut}>Cerrar sesión</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

AppBarHeader.propTypes = {
  onDrawerToggle: PropTypes.func.isRequired,
  mobileOpen: PropTypes.bool.isRequired,
};

export default AppBarHeader;
